// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__fEkxv","formInputBox":"login_formInputBox__3LYxU","logo":"login_logo__fwztG","loginBox":"login_loginBox__mUWy3"};